import {
  getGroupsV2,
  usePaginatedApi,
  GroupResponseV2,
  type PaginatedResponse,
} from 'api';
import { STALE_TIME_MS, DefaultPageParam } from 'api/search';
import usePaginationV2, {
  DEFAULT_CARD_ITEMS_PER_PAGE,
} from 'components/hooks/usePaginationV2';
import { QUERY_KEY_ROOTS } from 'variables';

export const useGetPaginatedGroups = (searchTerm?: string) => {
  const {
    data,
    isFetching,
    status,
    hasNextPage: hasMore,
    fetchNextPage: loadMore,
  } = usePaginatedApi<
    PaginatedResponse<GroupResponseV2>,
    GroupResponseV2,
    DefaultPageParam
  >({
    fetchPage: getGroupsV2,
    queryKey: [QUERY_KEY_ROOTS.GROUPS_DATA, QUERY_KEY_ROOTS.PAGINATED_DATA],
    getItemsFromPage: (p) => p.response ?? [],
    initialPageParam: undefined,
    queryParams: searchTerm ? { searchTerm } : undefined,
    staleTime: STALE_TIME_MS,
  });
  const { items = [], totalCount = 0 } = data ?? {};
  const paginator = usePaginationV2(
    items,
    DEFAULT_CARD_ITEMS_PER_PAGE,
    totalCount,
  );
  return {
    items,
    isFetching,
    status,
    hasMore,
    loadMore,
    paginator,
  };
};
